import styled from '../../../../../utils/styling/styled';

import { animated } from '../../../../../utils/styling/spring';

export const Hamburger = styled(animated.svg)`
  fill: white;
  width: 1.5rem;
`;
